import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "../css/login.css";
import waaNewLogo from "../assets/waa-new-logo.png";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  cacheInfo,
  forgotPassword,
  loginUser,
  logoutUser,
  redirectToDashboard,
  redirectToLogin,
  resendVerification,
  setUserData,
  verifyEmail,
} from "../store/actions/auth/authActions";
import { useState } from "react";
import {
  faCheck,
  faCircleXmark,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { act } from "react-dom/test-utils";
import { Cache } from "aws-amplify";

import {
  ERROR_ALERT,
  toggleShowAlert,
  SUCCESS_ALERT,
} from "../store/actions/commonActions";
import { connect } from "react-redux";
import { withRouter, useLocation } from "react-router-dom";

const Login = (props) => {
  const defaultCountdown = 60; //In Seconds;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [activeTab, setActiveTab] = useState("Login Screen");
  const [passScreen, setPassScreen] = useState("emailscreen");
  const [isLoading, setIsLoading] = useState(true);
  const [isVerified, setIsVerified] = useState(true);

  const [canResend, setCanResend] = useState(true);
  const [resendCountdown, setResendCountdown] = useState(defaultCountdown);

  const [canForget, setCanForget] = useState(true);
  const [forgetCountdown, setForgetCountdown] = useState(defaultCountdown);

  const passTabs = ["emailscreen", "newpass", "success"];

  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [showTempPassword, setshowTempPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRetypePassword, setShowRetypePassword] = useState(false);

  const search = useLocation().search;

  useEffect(() => {
    // Check if there is a verification token in the URL
    const searchParams = new URLSearchParams(search);
    const verificationToken = searchParams.get("verify");

    if (verificationToken) {
      verifyEmail(verificationToken)
        .then((response) => {
          const success = response.status_code;
          if (success === 200) {
            props.toggleShowAlert(
              true,
              SUCCESS_ALERT,
              "Account Verification Successful"
            );
          } else {
            props.toggleShowAlert(true, ERROR_ALERT, response.status_message);
          }
        })
        .catch((error) => {
          props.toggleShowAlert(true, ERROR_ALERT, error);
        });
    }
  }, []);

  const swtichTab = (tab) => {
    setActiveTab(tab);
  };

  const nextScreen = () => {
    const currentIndex = passTabs.indexOf(passScreen);
    console.log(currentIndex);
    if (currentIndex < passTabs.length - 1) {
      const nextTab = passTabs[currentIndex + 1];
      setPassScreen(nextTab);
    }
  };

  const previousScreen = () => {
    const currentIndex = passTabs.indexOf(passScreen);
    if (currentIndex > 0) {
      const previousTab = passTabs[currentIndex - 1];
      setPassScreen(previousTab);
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const credentials = {
        email,
        password,
      };
      await loginUser(credentials).then((response) => {
        if (response) {
          const userData = Cache.getItem("userdata");
          const isDisabled = parseInt(userData?.userDetails?.is_disabled) === 0;
          const isVerified = parseInt(userData?.userDetails?.is_verified) === 1;

          if (isDisabled && isVerified) {
            props.toggleShowAlert(true, SUCCESS_ALERT, "Login Successful");
            redirectToDashboard();
          } else {
            console.log(isDisabled);
            if (!isDisabled) {
              props.toggleShowAlert(
                true,
                ERROR_ALERT,
                "User account is disabled. Please contact the WeAreAyala Administrator."
              );
            } else if (isVerified !== 1) {
              props.toggleShowAlert(
                true,
                ERROR_ALERT,
                "Email not yet verified."
              );
            }
            // logoutUser()
            localStorage.clear();
            Cache.clear();
            setIsLoading(false);
          }
        } else {
          props.toggleShowAlert(
            true,
            ERROR_ALERT,
            "Invalid credentials or User does not exist"
          );
        }
      });
    } catch (error) {
      props.toggleShowAlert(true, ERROR_ALERT, error);
    }
  };

  const handleForgotPassSubmit = async (e) => {
    e.preventDefault();
    const credentials = {
      email,
    };
    const result = await forgotPassword(credentials);
    if (result) {
      setCanForget(false);
      setForgetCountdown(defaultCountdown);
      props.toggleShowAlert(
        true,
        SUCCESS_ALERT,
        "Password reset email has been sent."
      );
    } else {
      props.toggleShowAlert(
        true,
        ERROR_ALERT,
        "Password reset error. The credentials are either incorrect, disabled, or does not exist."
      );
    }
  };

  const handleSetNewPassSubmit = async (e) => {
    e.preventDefault();
    const credentials = {
      email,
    };
    const result = await forgotPassword(credentials);

    if (result) {
      props.toggleShowAlert(
        true,
        SUCCESS_ALERT,
        "Password reset email has been sent."
      );
    } else {
      props.toggleShowAlert(
        true,
        ERROR_ALERT,
        "Password reset error. The credentials are either incorrect, disabled, or does not exist."
      );
    }
  };

  const handleResendEmailVerification = async (e) => {
    e.preventDefault();
    const credentials = {
      email,
    };
    const result = await resendVerification(credentials);
    if (!result) {
      props.toggleShowAlert(true, ERROR_ALERT, result.status_message);
    } else {
      setCanResend(false);
      setResendCountdown(defaultCountdown);
      props.toggleShowAlert(
        true,
        SUCCESS_ALERT,
        "Successfully Resent The Verification Email"
      );
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (resendCountdown !== 1 && canResend !== true) {
        setResendCountdown(resendCountdown - 1);
      } else {
        setCanResend(true);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [resendCountdown, canResend]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (forgetCountdown !== 1 && canForget !== true) {
        setForgetCountdown(forgetCountdown - 1);
      } else {
        setCanForget(true);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [forgetCountdown, canForget]);

  const toggleLoginPasswordVisibility = () => {
    setShowLoginPassword(!showLoginPassword);
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleRetypePasswordVisibility = () => {
    setShowRetypePassword(!showRetypePassword);
  };

  const toggleTempPasswordVisibility = () => {
    setshowTempPassword(!showTempPassword);
  };

  const loginPasswordType = showLoginPassword ? "text" : "password";
  const tempPasswordType = showTempPassword ? "text" : "password";
  const newPasswordType = showNewPassword ? "text" : "password";
  const retypePasswordType = showRetypePassword ? "text" : "password";

  const LoginFields = (
    <form className="content-container" onSubmit={handleLoginSubmit}>
      <input
        type="email"
        placeholder="Email"
        className="form-control mb-2 login-text-fields"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <div className="input-container">
        <input
          type={loginPasswordType}
          placeholder="Password"
          className="form-control login-text-fields"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <div className="icon-container" onClick={toggleLoginPasswordVisibility}>
          <FontAwesomeIcon icon={showLoginPassword ? faEye : faEyeSlash} />
        </div>
      </div>
      <div className="d-flex gap-2 justify-content-between">
        <div
          className="forgot-password-link mb-3"
          onClick={() => swtichTab("Forgot Password")}
        >
          Forgot Password?
        </div>
        <div
          className="resend-link mb-3"
          onClick={() => swtichTab("Resend Verification")}
        >
          Resend Email Verification
        </div>
      </div>
      <button className="btn login-btn">Login</button>
    </form>
  );

  const ForgotPassword = (
    <>
      <div className="fw-bold">Forgot Password</div>
      <form className="content-container" onSubmit={handleForgotPassSubmit}>
        <input
          type="email"
          placeholder="Email"
          className="form-control mb-2 login-text-fields"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <div>&nbsp;</div>
        {canForget ? (
          <button className="btn login-btn">Submit</button>
        ) : (
          <button disabled className="btn login-btn">
            Resend in {forgetCountdown}
          </button>
        )}
        <div
          className="back-button mb-3"
          onClick={() => swtichTab("Login Fields")}
        >
          Back
        </div>
      </form>
    </>
  );

  const LoggingIn = (
    <>
      <div className="d-flex justify-content-center flex-column align-items-center gap-4">
        <div className="field-header">Logging In</div>
        <Spinner animation="border" size="lg" />
      </div>
      <div></div>
      <div></div>
    </>
  );

  const ResendVerification = (
    <>
      <div className="fw-bold">Resend Email Verification</div>
      <form
        className="content-container"
        onSubmit={handleResendEmailVerification}
      >
        <input
          type="email"
          placeholder="Email"
          className="form-control mb-2 login-text-fields"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <div>&nbsp;</div>
        {canResend ? (
          <button className="btn login-btn">Submit</button>
        ) : (
          <button disabled className="btn login-btn">
            Resend in {resendCountdown}
          </button>
        )}
        <div
          className="back-button mb-3"
          onClick={() => swtichTab("Login Fields")}
        >
          Back
        </div>
      </form>
    </>
  );

  const errorPage = (
    <>
      <div>Error loading...</div>
    </>
  );

  const FirstTimeScreen = () => {
    switch (passScreen) {
      case "emailscreen":
        return FirstTimeLogin;
      case "newpass":
        return FirstTimeSetNewPass;
      case "success":
        return FirstTimeSuccessPass;
      default:
        return errorPage;
    }
  };

  const FirstTimeLogin = (
    <div className="content-container">
      <div className="field-header">First Time Login</div>
      <input
        type="email"
        placeholder="Email"
        className="form-control mb-2 login-text-fields"
      />
      <div className="input-container">
        <input
          type={tempPasswordType}
          placeholder="Temporary Password"
          className="form-control login-text-fields"
        />
        <div className="icon-container" onClick={toggleTempPasswordVisibility}>
          <FontAwesomeIcon icon={showNewPassword ? faEye : faEyeSlash} />
        </div>
      </div>
      <button className="btn login-btn" onClick={nextScreen}>
        Next
      </button>
    </div>
  );

  const FirstTimeSetNewPass = (
    <>
      <form
        className="content-container"
        onSubmit={handleSetNewPassSubmit}
      ></form>
      <div className="field-header">Set New Password</div>
      <div className="input-container">
        <input
          type={newPasswordType}
          placeholder="New Password"
          className="form-control login-text-fields"
        />
        <div className="icon-container" onClick={toggleNewPasswordVisibility}>
          <FontAwesomeIcon icon={showNewPassword ? faEye : faEyeSlash} />
        </div>
      </div>

      <div className="input-container">
        <input
          type={retypePasswordType}
          placeholder="Re-type New Password"
          className="form-control login-text-fields"
        />
        <div
          className="icon-container"
          onClick={toggleRetypePasswordVisibility}
        >
          <FontAwesomeIcon icon={showRetypePassword ? faEye : faEyeSlash} />
        </div>
      </div>
      <button className="btn login-btn" onClick={nextScreen}>
        Submit
      </button>
      <div className="back-button mb-3" onClick={previousScreen}>
        Back
      </div>
    </>
  );

  const FirstTimeSuccessPass = (
    <>
      <div>
        <div className="field-header">Successfully Changed Password!</div>
        <FontAwesomeIcon icon={faCheck} className="login-assets" />
      </div>
      <form
        className="content-container align-items-center"
        onSubmit={handleLoginSubmit}
      >
        <button className="btn login-btn w-100">Login</button>
      </form>
    </>
  );

  const DisplayFields = <>{isVerified ? LoginFields : FirstTimeScreen}</>;

  return (
    <>
      <div className="d-flex justify-content-center align-items-center login-container ">
        <div className="login-box">
          <div className="login-icon">
            <img
              className="company-logo"
              src={waaNewLogo}
              alt="waa-logo"
              width="100%"
              height="auto"
            />
          </div>
          {activeTab === "Login Screen" && DisplayFields}
          {activeTab === "Login Fields" && LoginFields}
          {activeTab === "Forgot Password" && ForgotPassword}
          {activeTab === "First Time Login" && FirstTimeScreen()}
          {activeTab === "Resend Verification" && ResendVerification}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  common: state.common,
});

const mapDispatchToProps = (dispatch) => {
  return {
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
